import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bp-icon-Filters" }
const _hoisted_2 = {
  key: 0,
  class: "filter-notification"
}
const _hoisted_3 = {
  key: 0,
  class: "btn-back-container"
}
const _hoisted_4 = {
  key: 1,
  class: "filter-container-title"
}
const _hoisted_5 = { class: "btn-container" }
const _hoisted_6 = { key: 0 }

import { ref, onMounted, onUnmounted, watch } from 'vue';
import { Filter, FilterValue } from "@/models/frontend/FiltersModels";
import SearchInputComponent from '@/components/core/fields/SearchInput/SearchInputComponent.vue';
import SliderSelectorComponent from '@/components/core/fields/SliderSelector/SliderSelectorComponent.vue';
import DropdownMultiSelectComponent from '@/components/core/fields/DropdownMultiSelect/DropdownMultiSelectComponent.vue';
import InputNumberComponent from '@/components/core/fields/InputNumber/InputNumberComponent.vue';
import DatePickerComponent from '@/components/core/fields/DatePicker/DatePickerComponent.vue';
import { useStore } from 'vuex';
import { FilterDefaultPostalCode } from '@/beepallet.consts';
import { isMobile, isTablet } from '@/helpers/CommonHelper';


export default /*@__PURE__*/_defineComponent({
  __name: 'FiltersComponent',
  props: {
    filters: {},
    numberFilters: {}
  },
  emits: ['applyFilters', 'clearFilters', 'update:filters'],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const props = __props;
const emit = __emit;

const showFilters = ref(false); // Estado para mostrar u ocultar filtros en móvil
const visibleFiltersCount = ref(6);
const allFiltersVisible = ref(false);
const previousValue = ref<'MOBILE' | 'TABLET' | 'DESKTOP'>('DESKTOP');

//Propiedad para rellenar el código postal en móvil
const pCode = ref<string>('');

const searchMobile = (data:string) => {
  const filter = props.filters.find((filter) => filter.id === 'pcode');
  if (filter) filter.value = data;
  updateFiltersHandler('pcode', data)
  emit("applyFilters");
}

const handleFilterListView = () => {
  if(isTablet.value){
    visibleFiltersCount.value = 5;
    if(previousValue.value!='TABLET'){
      allFiltersVisible.value = false;
    }
  }
  else if(!isTablet.value && !isMobile.value){
    visibleFiltersCount.value = 6;
    if(previousValue.value!='DESKTOP'){
      allFiltersVisible.value = false;
    }
  }
  else if(isMobile.value){
    visibleFiltersCount.value =  props.filters.length;
    allFiltersVisible.value = true;
  }
};

// Alternar el estado de los filtros en móvil
const toggleFilters = () => {
  showFilters.value = !showFilters.value;
};

const toggleAdvancedFilters = () => {
  if(!isMobile.value){
      if (!allFiltersVisible.value) {
        visibleFiltersCount.value = props.filters.length;
    } else {
        visibleFiltersCount.value = (isTablet.value)? 5 : 6;
    }
      allFiltersVisible.value = !allFiltersVisible.value;
    } 
}

// Agregar event listener para manejar el cambio de tamaño de ventana
onMounted(() => {
  previousValue.value = (isTablet.value)?'TABLET':(isMobile.value)?'MOBILE':'DESKTOP';
  handleFilterListView();
  window.addEventListener('resize', handleFilterListView);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleFilterListView);
});

const submit = () => {
  emit("applyFilters");
  toggleFilters();
}

const clearData = () => {
  emit('clearFilters')
}

// **Actualizar los filtros sin modificar `props.filters` directamente**
const updateFiltersHandler = (id: string, value: FilterValue) => {
  const filter = props.filters.find((filter) => filter.id === id);

  if (id === "pcode") {
    store.dispatch('updatePostalCode', value);
  }
  if (filter) filter.value = value;
  emit("update:filters", props.filters);
};

// Sincronizar localFilters con props.filters cuando cambia
watch(() => props.filters, (newFilters) => {
  const filter = newFilters.find((filter) => filter.id === 'pcode');
  if (filter?.value) pCode.value = filter.value as string;
}, { deep: true, immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["filters-mobile", {'is-open': showFilters.value}])
        }, [
          _createVNode(SearchInputComponent, {
            class: "filters-mobile_input",
            placeholder: "Selecciona",
            label: "distancia",
            modelValue: pCode.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pCode).value = $event)),
            initialValue: (_unref(store).getters.postalCode) ? _unref(store).getters.postalCode : _unref(FilterDefaultPostalCode),
            onSearch: searchMobile,
            onUpdateValue: updateFiltersHandler
          }, null, 8, ["modelValue", "initialValue"]),
          _createElementVNode("button", {
            class: "btn-notification btn-secondary-m btn-icon-underline-black",
            onClick: toggleFilters
          }, [
            _createElementVNode("i", _hoisted_1, [
              (_ctx.numberFilters!==0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.numberFilters), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "Ver filtros", -1))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["filter-container", { 'is-mobile': _unref(isMobile), 'is-open': _unref(isMobile) && showFilters.value }])
    }, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "close-button",
              onClick: toggleFilters
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "bp-icon-Back" }, null, -1),
              _createElementVNode("span", null, "volver", -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Filtrar por:"))
        : _createCommentVNode("", true),
      _createVNode(_TransitionGroup, {
        name: "fade",
        tag: "ul",
        class: _normalizeClass(['filter-container-list', { 'is-mobile': _unref(isMobile)}])
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters.slice(0, visibleFiltersCount.value), (filter) => {
            return (_openBlock(), _createElementBlock("li", {
              key: filter.id
            }, [
              (filter.type==="text-search")
                ? (_openBlock(), _createBlock(SearchInputComponent, {
                    key: 0,
                    placeholder: filter.placeholder,
                    label: filter.label,
                    id: filter.id,
                    initialValue: filter.value,
                    modelValue: filter.value,
                    "onUpdate:modelValue": ($event: any) => ((filter.value) = $event),
                    onSearch: searchMobile,
                    onUpdateValue: updateFiltersHandler
                  }, null, 8, ["placeholder", "label", "id", "initialValue", "modelValue", "onUpdate:modelValue"]))
                : (filter.type==='slider')
                  ? (_openBlock(), _createBlock(SliderSelectorComponent, {
                      key: 1,
                      placeholder: filter.placeholder,
                      minValue: filter.min,
                      maxValue: filter.max,
                      unit: filter.unit,
                      label: filter.label,
                      modelValue: filter.value,
                      "onUpdate:modelValue": ($event: any) => ((filter.value) = $event),
                      initialValue: filter.initialValue,
                      id: filter.id,
                      onUpdateSlider: updateFiltersHandler
                    }, null, 8, ["placeholder", "minValue", "maxValue", "unit", "label", "modelValue", "onUpdate:modelValue", "initialValue", "id"]))
                  : (filter.type==='dropdown-multiselect')
                    ? (_openBlock(), _createBlock(DropdownMultiSelectComponent, {
                        key: 2,
                        id: filter.id,
                        options: filter.options,
                        "model-value": Array.isArray(filter.value) ? filter.value : [],
                        placeholder: filter.placeholder,
                        label: filter.label,
                        onUpdateFilters: updateFiltersHandler
                      }, null, 8, ["id", "options", "model-value", "placeholder", "label"]))
                    : (filter.type==='numeric-input')
                      ? (_openBlock(), _createBlock(InputNumberComponent, {
                          key: 3,
                          placeholder: filter.placeholder,
                          label: filter.label,
                          modelValue: filter.value,
                          "onUpdate:modelValue": ($event: any) => ((filter.value) = $event),
                          id: filter.id,
                          onUpdateNumber: updateFiltersHandler
                        }, null, 8, ["placeholder", "label", "modelValue", "onUpdate:modelValue", "id"]))
                      : (filter.type==='date-selector')
                        ? (_openBlock(), _createBlock(DatePickerComponent, {
                            key: 4,
                            modelValue: filter.value,
                            "onUpdate:modelValue": [($event: any) => ((filter.value) = $event), updateFiltersHandler],
                            label: filter.label,
                            minDate: filter.minDate,
                            id: filter.id
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "minDate", "id"]))
                        : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(isMobile))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn-toggle btn-secondary-m btn-icon-underline-black",
                onClick: toggleAdvancedFilters
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(['bp-icon-Chevron', { 'active': allFiltersVisible.value }])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString((allFiltersVisible.value) ? 'ocultar' : 'ver') + " filtros avanzados", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-secondary-m btn-underline-black",
            onClick: clearData
          }, "borrar filtros"),
          _createElementVNode("button", {
            class: "btn-primary-m btn-primary-green",
            onClick: submit
          }, "aplicar filtros")
        ])
      ])
    ], 2)
  ], 64))
}
}

})